import React from "react";
import Page from "../ui/Page";

const Subject=()=>{

  return (
    <Page title="Welcome to Ideal Training Academy">
    
   Subjects
      
    </Page>
  );
}

export {Subject};

